module.exports = __webpack_public_path__ + "img/horse-face.4f6730e0.png";